import { Col } from "@commonlibs";
import useIsLoggedIn from "ui/auth/hooks/useIsLoggedIn";
import BaseLayout from "ui/common/components/layout/BaseLayout/BaseLayout";
import FullLogo from "../../components/display/FullLogo/FullLogo";
import BackgroundLayoutWithLogo from "ui/common/components/layout/BackgroundLayoutWithLogo/BackgroundLayoutWithLogo";

const LOADING_PAGE_CONFIG = {
    true: {
        color: "primary" as const,
        Layout: BaseLayout,
    },
    false: {
        color: "white" as const,
        Layout: BackgroundLayoutWithLogo,
    },
};

const LoadingPage = (): JSX.Element => {
    const { Layout, color } = LOADING_PAGE_CONFIG[`${useIsLoggedIn()}`];
    return (
        <Layout>
            <Col alignItems="center" justifyContent="center" flex={1}>
                <FullLogo color={color} size="md" variant="purple" />
            </Col>
        </Layout>
    );
};

export default LoadingPage;
